<mat-spinner *ngIf="!progressBar" color="accent"></mat-spinner>
<div *ngIf="progressBar">
  <mat-progress-bar color="accent" mode="determinate" [value]="value"></mat-progress-bar>
</div>
